import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";

export type ResumeIndicatorM1ByHealthTeamParams = PaginationFilter & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	ine?: string;
	export?: boolean;
};

export class ResumeIndicatorM1ByHealthTeamData {
	healthTeamId: number = 0;
	healthTeamIne: string = "";
	healthTeamName: string = "";
	totalCitizens: number = 0;
	totalAttendances: number = 0;
}

export async function getResumeIndicatorM1ByHealthTeam({
	uf,
	ibgeCode,
	...params
}: ResumeIndicatorM1ByHealthTeamParams) {
	const response = await esusApi.get<Paginated<ResumeIndicatorM1ByHealthTeamData>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/emulti/m1/health-teams-resume`,
		params
	);
	return response.data ?? new Paginated<ResumeIndicatorM1ByHealthTeamData>();
}
